/** `document.activeElement` stops at a shadow host; descend to the real focused node. */
export const getDeepActiveElement = (): HTMLElement | null => {
    let active: Element | null = document.activeElement;
    while (active?.shadowRoot?.activeElement) {
        active = active.shadowRoot.activeElement;
    }
    return active instanceof HTMLElement ? active : null;
};
